// moneris-payment.js
// Handles both the Selector (mode picker) and the Invoice/Retainer checkout flows.
// No jQuery — uses fetch + standard DOM APIs.

(function () {
    'use strict';

    // ── reCAPTCHA ─────────────────────────────────────────────────────────────────

    // Globals required by Google's reCAPTCHA v2 explicit render API
    window.onloadRecaptchaCallback = function () {
        var badge = document.querySelector('.g-recaptcha');
        if (!badge) return;
        grecaptcha.render(badge, {
            sitekey: badge.dataset.sitekey
        });
    };

    if (document.querySelector('.g-recaptcha')) {
        var s = document.createElement('script');
        s.src = 'https://www.google.com/recaptcha/api.js?onload=onloadRecaptchaCallback&render=explicit';
        s.async = true;
        s.defer = true;
        document.body.appendChild(s);
    }

    // ── Selector (Index) view ─────────────────────────────────────────────────────

    function initPaymentSelector() {
        var widget = document.querySelector('.moneris-payment-widget.selector');
        if (!widget) return;

        var form = document.getElementById('paymentSelectorForm');
        if (!form) return;

        document.getElementById('submitPaymentSelectorForm').addEventListener('click', function () {
            var selected = form.querySelector('input[name="radSelectForm"]:checked');
            if (!selected) return;

            var mode      = selected.value; // "Invoice" or "Retainer"
            var targetUrl = mode === 'Retainer'
                ? (widget.dataset.retainerUrl || null)
                : (widget.dataset.invoiceUrl  || null);

            if (targetUrl) {
                window.location.href = targetUrl;
            } else {
                // Fall back to appending the mode to the current path
                var path = window.location.pathname.replace(/\/?$/, '/');
                window.location.href = path + mode.toLowerCase();
            }
        });
    }

    // ── Invoice / Retainer checkout flow ─────────────────────────────────────────

    function initCheckout() {
        var widget = document.querySelector('.moneris-payment-widget[data-checkout-mode]');
        if (!widget) return;
        if (typeof monerisCheckout === 'undefined') {
            console.warn('[moneris-payment] monerisCheckout SDK not loaded.');
            return;
        }

        var checkoutMode = widget.dataset.checkoutMode; // "Invoice" | "Retainer"
        var monerisMode  = widget.dataset.monerisMode;  // "prod"    | "qa"

        if (!checkoutMode || !monerisMode) return;

        var isFrench        = (document.documentElement.lang || '').toLowerCase().startsWith('fr');
        var paymentData     = {};
        var paymentComplete = false;
        var paymentApproved = false;

        // ── Currency formatting ───────────────────────────────────────────────────

        function formatCurrency(amount) {
            return isFrench
                ? amount.toFixed(2) + ' $'
                : '$' + amount.toFixed(2);
        }

        // ── Modal open / close ────────────────────────────────────────────────────

        function openMonerisModal() {
            // Move to <body> on first open so it escapes main's z-index:10 / footer's z-index:20
            var modal = document.getElementById('monerisModal');
            if (modal && modal.parentNode !== document.body) {
                document.body.appendChild(modal);
            }
            if (modal) modal.style.display = '';
            document.body.classList.add('moneris-open');

            // Hide the reCAPTCHA checkbox once the payment window is open — it's no
            // longer needed at this point, and a timeout would otherwise confuse users.
            var recaptcha = document.querySelector('.g-recaptcha');
            if (recaptcha) recaptcha.style.display = 'none';
        }

        function closeMonerisModal() {
            var modal = document.getElementById('monerisModal');
            if (modal) modal.style.display = 'none';
            document.body.classList.remove('moneris-open');

            if (paymentComplete) {
                var panel = paymentApproved
                    ? widget.querySelector('.paymentSuccessPanel')
                    : widget.querySelector('.paymentDeclinedPanel');
                if (panel) {
                    panel.style.display = '';
                    panel.scrollIntoView({ behavior: 'smooth' });
                }
            } else {
                var reopen = document.getElementById('reopenCheckoutWrapper');
                if (reopen) reopen.style.display = '';
            }
        }

        // ── Form enable / disable ─────────────────────────────────────────────────

        function disableForm() {
            var form = document.getElementById('paymentForm');
            if (!form) return;
            form.querySelectorAll('input, select, textarea, button').forEach(function (el) {
                el.disabled = true;
            });
            form.classList.add('disabled');
        }

        function enableForm() {
            var form = document.getElementById('paymentForm');
            if (!form) return;
            form.querySelectorAll('input, select, textarea, button').forEach(function (el) {
                el.disabled = false;
            });
            form.classList.remove('disabled');
        }

        // ── Moneris SDK callbacks ─────────────────────────────────────────────────

        function enforceIframeSizing() {
            var checkoutDiv = document.getElementById('monerisCheckout');
            var iframe = checkoutDiv && checkoutDiv.querySelector('iframe');
            if (!iframe) return;

            // Avoid re-triggering the MutationObserver below when we're the ones setting the style.
            if (iframe.style.width === '100%' && iframe.style.maxWidth === '100%') return;

            // The Moneris SDK sets its own inline width/height on the iframe (sometimes based on
            // window.innerWidth) after our CSS has already applied, causing horizontal overflow
            // inside #monerisCheckout. Re-assert sizing here with 'important' priority so ours
            // always wins, regardless of what the SDK sets afterward.
            iframe.style.setProperty('width', '100%', 'important');
            iframe.style.setProperty('max-width', '100%', 'important');
        }

        function onPageLoaded() {
            disableForm();
            openMonerisModal();
            enforceIframeSizing();
        }

        function onCancelTransaction() {
            // Nothing to do — user chose to cancel within the Moneris iframe
        }

        function onErrorEvent(errorJson) {
            console.error('[moneris-payment] SDK error event:', errorJson);
        }

        function onPaymentReceipt(responseJson) {
            paymentComplete = true;

            var response;
            try { response = JSON.parse(responseJson); } catch (e) { return; }

            var receiptPayload = {
                ticket:        response.ticket,
                checkout_mode: checkoutMode
            };

            fetch('/api/moneris/receipt', {
                method:  'POST',
                headers: { 'Content-Type': 'application/json' },
                body:    JSON.stringify(receiptPayload)
            })
            .then(function (res) { return res.json(); })
            .then(function (data) {
                // "a" = approved. Anything else (declined, missing receipt, request failure) is treated as not approved.
                if (data.success && data.receipt && data.receipt.result === 'a') {
                    console.log('[moneris-payment] Receipt:', data.receipt);
                    paymentApproved = true;
                    showSuccessPanel(data.receipt.amount);
                } else {
                    console.warn('[moneris-payment] Payment declined or receipt unsuccessful:', data);
                    paymentApproved = false;
                    showDeclinedPanel();
                }
            })
            .catch(function (err) {
                console.error('[moneris-payment] Failed to retrieve receipt:', err);
                paymentApproved = false;
                showDeclinedPanel();
            });
        }

        function onPaymentComplete() {
            closeMonerisModal();
        }

        // ── Success / declined panels ─────────────────────────────────────────────

        function showSuccessPanel(amount) {
            var heading  = widget.querySelector('.success-heading');
            var message  = widget.querySelector('.success-message');
            var rawMsg   = widget.dataset.successMessage || 'Your payment has been processed successfully.';
            var rawHdg   = widget.dataset.successHeading || 'Payment received';

            if (heading) heading.textContent = rawHdg;
            if (message) {
                var displayAmount = amount ? formatCurrency(parseFloat(amount)) : '';
                message.textContent = rawMsg.replace('{amount}', displayAmount);
            }
        }

        function showDeclinedPanel() {
            var heading = widget.querySelector('.declined-heading');
            var message = widget.querySelector('.declined-message');
            var rawHdg  = widget.dataset.declinedHeading || 'Payment not completed';
            var rawMsg  = widget.dataset.declinedMessage || 'Unfortunately your payment could not be processed. Please try again.';

            if (heading) heading.textContent = rawHdg;
            if (message) message.textContent = rawMsg;
        }

        // ── Moneris SDK setup ─────────────────────────────────────────────────────

        var myCheckout = new monerisCheckout();
        myCheckout.setMode(monerisMode);
        myCheckout.setCheckoutDiv('monerisCheckout');
        myCheckout.setCallback('page_loaded',        onPageLoaded);
        myCheckout.setCallback('cancel_transaction', onCancelTransaction);
        myCheckout.setCallback('error_event',        onErrorEvent);
        myCheckout.setCallback('payment_receipt',    onPaymentReceipt);
        myCheckout.setCallback('payment_complete',   onPaymentComplete);

        // ── Modal control buttons ───────────────────────────────────────────

        var closeBtn = document.getElementById('closeModalBtn');
        if (closeBtn) closeBtn.addEventListener('click', closeMonerisModal);

        var reopenBtn = document.getElementById('reopenCheckoutBtn');
        if (reopenBtn) reopenBtn.addEventListener('click', function () {
            document.getElementById('reopenCheckoutWrapper').style.display = 'none';
            openMonerisModal();
        });

        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') {
                var modal = document.getElementById('monerisModal');
                if (modal && modal.style.display !== 'none') closeMonerisModal();
            }
        });

        var payAnotherBtn = document.getElementById('payAnotherBtn');
        if (payAnotherBtn) payAnotherBtn.addEventListener('click', function () {
            window.location.reload();
        });

        var tryAgainBtn = document.getElementById('tryAgainBtn');
        if (tryAgainBtn) tryAgainBtn.addEventListener('click', function () {
            window.location.reload();
        });

        // ── Preload request ───────────────────────────────────────────────────────

        // Resolves a human-friendly label for a form field, falling back
        // gracefully when the field has no id (e.g. repeated invoice rows).
        function getFieldLabel(el) {
            var label = null;
            if (el.id) {
                label = document.querySelector('label[for="' + el.id + '"]');
            }
            if (!label) {
                var container = el.closest('.flex-col') || el.closest('div');
                if (container) label = container.querySelector('label');
            }
            if (label) return label.textContent.trim();
            return el.getAttribute('aria-label') || el.placeholder || el.name || 'A required field';
        }

        // Builds a single alert message listing each invalid field along with
        // its specific validation problem (required, pattern mismatch, etc.).
        function buildValidationMessage(invalidFields) {
            var lines = invalidFields.map(function (el) {
                var fieldName = getFieldLabel(el);
                var detail    = el.validationMessage || 'is invalid.';
                return '\u2022 ' + fieldName + ': ' + detail;
            });
            return 'Please correct the following before continuing:\n\n' + lines.join('\n');
        }

        function collectAndValidate() {
            var isValid = true;

            paymentData = {};
            paymentData.checkout_mode    = checkoutMode;
            paymentData.recaptcha_token  = (document.querySelector('.g-recaptcha-response') || {}).value || '';
            paymentData.min_amount       = widget.dataset.minAmount || '';

            if (checkoutMode === 'Invoice') {
                paymentData.client_number = (document.getElementById('client_number') || {}).value || '';

                var invoices       = [];
                var amountMismatch = false;
                document.querySelectorAll('.invoice-item').forEach(function (item) {
                    var amt     = item.querySelector('.invoice-amount').value;
                    var confirm = item.querySelector('.invoice-amount-confirm').value;
                    if (amt !== confirm) amountMismatch = true;
                    invoices.push({
                        invoice_number:    item.querySelector('.invoice-number').value,
                        txn_total:         amt,
                        txn_total_confirm: confirm
                    });
                });
                paymentData.invoices = invoices;

                if (amountMismatch) {
                    alert('One or more invoice amounts do not match their confirmation. Please correct and try again.');
                    return false;
                }
            }

            if (checkoutMode === 'Retainer') {
                paymentData.client_number     = (document.getElementById('client_number')           || {}).value || '';
                paymentData.txn_total         = (document.getElementById('invoice_amount')          || {}).value || '';
                paymentData.txn_total_confirm = (document.getElementById('invoice_amount_confirm')  || {}).value || '';

                if (paymentData.txn_total !== paymentData.txn_total_confirm) {
                    alert('The amounts do not match. Please correct and try again.');
                    return false;
                }
            }

            // HTML5 constraint validation
            var invalidFields = [];
            document.querySelectorAll('.moneris-payment-widget :is(input, select, textarea)').forEach(function (el) {
                if (el.checkValidity && !el.checkValidity()) {
                    isValid = false;
                    invalidFields.push(el);
                }
            });
            if (!isValid) {
                alert(buildValidationMessage(invalidFields));
                invalidFields[0].reportValidity();
                invalidFields[0].focus();
                return false;
            }

            if (!paymentData.recaptcha_token) {
                alert('Please check the box to confirm you are not a robot.');
                return false;
            }

            return true;
        }

        function doPreloadRequest() {
            if (!collectAndValidate()) return;

            disableForm();
            var loader = document.getElementById('paymentLoader');
            if (loader) loader.style.display = '';

            fetch('/api/moneris/preload', {
                method:  'POST',
                headers: { 'Content-Type': 'application/json' },
                body:    JSON.stringify(paymentData)
            })
            .then(function (res) {
                if (!res.ok) return res.json().then(function (e) { throw e; });
                return res.json();
            })
            .then(function (data) {
                // Moneris wraps the preload response inside a "response" key
                var inner = data.response || data;
                if ((inner.success === true || inner.success === 'true') && inner.ticket) {
                    myCheckout.startCheckout(inner.ticket);
                } else {
                    alert(inner.message || 'The payment gateway returned an error. Please try again.');
                    enableForm();
                }
            })
            .catch(function (err) {
                console.error('[moneris-payment] Preload error:', err);
                alert((err && err.message) || 'An error occurred while contacting the payment gateway. Please try again.');
                enableForm();
            })
            .finally(function () {
                if (loader) loader.style.display = 'none';
            });
        }

        // ── Form submit ───────────────────────────────────────────────────────────

        var submitBtn = document.getElementById('submitPaymentForm');
        if (submitBtn) submitBtn.addEventListener('click', doPreloadRequest);

        // ── Currency formatting on blur ───────────────────────────────────────────

        document.addEventListener('change', function (e) {
            var el = e.target;
            if (el.matches('#invoice_amount, #invoice_amount_confirm, .invoice-amount, .invoice-amount-confirm')) {
                var val = parseFloat(el.value);
                if (!isNaN(val)) el.value = val.toFixed(2);
                updateInvoiceTotal();
            }
        });

        // ── Restrict invoice number to 6 digits ──────────────────────────────

        document.addEventListener('input', function (e) {
            var el = e.target;
            if (el.matches('.invoice-number')) {
                el.value = el.value.replace(/\D/g, '').slice(0, 6);
            }
        });

        // ── Multi-invoice running total ─────────────────────────────────────

        function updateInvoiceTotal() {
            if (checkoutMode !== 'Invoice') return;
            var total = 0;
            document.querySelectorAll('.invoice-amount').forEach(function (el) {
                var v = parseFloat(el.value);
                if (!isNaN(v)) total += v;
            });
            var totalEl = document.getElementById('invoiceTotal');
            if (totalEl) totalEl.textContent = formatCurrency(total);
        }

        // ── Add / remove invoice rows (Invoice mode) ──────────────────────────────

        if (checkoutMode === 'Invoice') {
            var addBtn = document.getElementById('addInvoiceBtn');
            if (addBtn) addBtn.addEventListener('click', function () {
                var first = document.querySelector('.invoice-item');
                if (!first) return;

                var clone = first.cloneNode(true);
                clone.querySelectorAll('input').forEach(function (el) {
                    el.value = '';
                    el.classList.remove('userEdited');
                });

                if (!clone.querySelector('.remove-invoice-btn')) {
                    var removeBtn = document.createElement('button');
                    removeBtn.type = 'button';
                    removeBtn.title = 'Remove invoice';
                    removeBtn.className = 'remove-invoice-btn inline-flex cursor-pointer items-center gap-1.5 border-0 bg-transparent p-0 text-sm text-red-600 opacity-70 transition-opacity hover:opacity-100 focus-visible:outline-2 focus-visible:outline-red-600';
                    removeBtn.innerHTML = '<span class="icon icon-trash" aria-hidden="true"></span><span class="sr-only">Remove invoice</span>';
                    var header = clone.querySelector('.invoice-item-header');
                    (header || clone).appendChild(removeBtn);
                }

                document.querySelector('.invoice-items').appendChild(clone);
                reindexInvoices();
            });

            document.addEventListener('click', function (e) {
                var btn = e.target.closest('.remove-invoice-btn');
                if (btn) {
                    btn.closest('.invoice-item').remove();
                    reindexInvoices();
                }
            });

            function reindexInvoices() {
                var items = document.querySelectorAll('.invoice-item');
                var showIndex = items.length > 1;
                items.forEach(function (item, i) {
                    var idx = item.querySelector('.invoice-index');
                    if (idx) idx.textContent = i + 1;
                    var wrapper = item.querySelector('.invoice-index-wrapper');
                    if (wrapper) wrapper.style.display = showIndex ? '' : 'none';
                    // Remove the delete button from the first item
                    if (i === 0) {
                        var rb = item.querySelector('.remove-invoice-btn');
                        if (rb) rb.remove();
                    }
                });
                updateInvoiceTotal();
            }

            updateInvoiceTotal();
        }

        // ── "Touched" class for field styling ────────────────────────────────────

        document.addEventListener('change',     markEdited);
        document.addEventListener('keydown',    markEdited);
        document.addEventListener('touchstart', markEdited, { passive: true });
        function markEdited(e) {
            if (e.target.closest('#paymentForm')) e.target.classList.add('userEdited');
        }
    }

    // ── Boot ──────────────────────────────────────────────────────────────────────

    document.addEventListener('DOMContentLoaded', function () {
        initPaymentSelector();
        initCheckout();
    });

}());
